import React, { useEffect, useRef, useState } from 'react';

const WhyBodyDoubling = () => {
  const [isVisible, setIsVisible] = useState(false);
  const sectionRef = useRef(null);

  useEffect(() => {
    const currentSection = sectionRef.current;
    const observer = new IntersectionObserver(
      ([entry]) => {
        if (entry.isIntersecting) {
          setIsVisible(true);
        }
      },
      { threshold: 0.2 }
    );

    if (currentSection) {
      observer.observe(currentSection);
    }

    return () => {
      if (currentSection) {
        observer.unobserve(currentSection);
      }
    };
  }, []);

  return (
    <section ref={sectionRef} className="py-16 bg-white">
      <div className="max-w-3xl mx-auto px-4 sm:px-6 lg:px-8">
        <div className={`text-center transition-all duration-1000 ${isVisible ? 'opacity-100 translate-y-0' : 'opacity-0 translate-y-10'}`}>
          <h3 className="text-2xl sm:text-3xl font-semibold text-gray-900 mb-6">
            Why body doubling works
          </h3>

          <div className="space-y-4 text-lg text-gray-600 leading-relaxed">
            <p>
              Work feels easier when someone else is present. Simply showing up alongside another person creates a gentle sense of accountability—enough to stay focused, without pressure or performance.
            </p>

            <p>
              It's motivation through presence, not force. Knowing someone else chose to work during the same window helps reduce friction to starting—and makes it more likely you'll follow through.
            </p>
          </div>
        </div>
      </div>
    </section>
  );
};

export default WhyBodyDoubling;
